import { FC } from "react"
import { IconProps } from "@/components/shared/Icon"

const BlockIcon: FC<IconProps> = ({ ...props }) => {
   return (
      <svg
         viewBox="0 0 24 24"
         fill="none"
         {...props}
      >
         <rect
            x="2"
            y="2"
            width="20"
            height="20"
            rx="2"
            stroke="currentColor"
            strokeWidth="4"
            strokeLinejoin="round"
         />
      </svg>
   )
}

export default BlockIcon
